export default __webpack_public_path__ + "26b416b372518cfbc68b4e9dcc805c93.svg";